module.exports = __webpack_public_path__ + "static/media/card.f2febd96.svg";